import { service } from "@ember/service";
import Route from "@ember/routing/route";
import RSVP from "rsvp";
import ENV from "glesys-controlpanel/config/environment";

export default class DnsRoute extends Route {
  @service ajax;
  @service availableServices;

  buildRouteInfoMetadata() {
    return { jumpable: true };
  }

  beforeModel() {
    this.availableServices.requireAccessTo(this, "domains");
  }

  model() {
    let { project, organization } = this.modelFor("organization");

    return RSVP.hash({
      project,
      domains: project.get("dnsDomains"),
      pricelist: this.ajax.request(`${ENV.apiBaseUri}/domain/pricelist?organizationnumber=${organization.id}`),
    });
  }
}
